import React from 'react';

// Optimized icon components with React.memo
export const ChevronIcon = React.memo(
  ({direction, color}: {direction: 'up' | 'down'; color: string}) => (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        d={
          direction === 'up'
            ? 'M15 12.5L10 7.5L5 12.5'
            : 'M5 7.5L10 12.5L15 7.5'
        }
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
);
ChevronIcon.displayName = 'ChevronIcon';

export const PlusIcon = React.memo(() => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_13570_92527)">
      <path
        d="M10.001 6.664v6.667M6.668 9.997h6.667m5 0a8.333 8.333 0 11-16.667 0 8.333 8.333 0 0116.667 0z"
        stroke="#38BDF8"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_13570_92527">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
));
PlusIcon.displayName = 'PlusIcon';

export const MessageIcon = React.memo(
  ({hasComments}: {hasComments: boolean}) => (
    <svg width={21} height={20} viewBox="0 0 21 20" fill="none">
      <path
        d="M17.999 9.583a7.083 7.083 0 01-9.63 6.612c-.144-.055-.216-.083-.273-.096a.753.753 0 00-.156-.02c-.058-.003-.123.003-.252.017l-4.268.441c-.407.042-.61.063-.73-.01a.417.417 0 01-.195-.291c-.022-.14.076-.32.27-.679l1.363-2.523c.112-.208.168-.312.194-.412a.75.75 0 00.023-.27c-.008-.104-.053-.237-.143-.505a7.083 7.083 0 1113.797-2.264z"
        stroke={hasComments ? '#38BDF8' : '#A8A29E'}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
);
MessageIcon.displayName = 'MessageIcon';

export const AlertTriangleIcon = React.memo(() => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none">
    <path
      d="M8.575 3.325L1.825 15.1c-.225.393-.034.896.425 1.125.135.067.291.1.45.1h13.5c.459 0 .833-.374.833-.833a.83.83 0 0 0-.1-.4L9.183 3.317a.833.833 0 0 0-1.441-.034c-.061.1-.109.208-.133.325v.033L8.575 3.325z"
      fill="#EB8200"
      stroke="#EB8200"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.5v2.5M10 12.5h.008"
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
AlertTriangleIcon.displayName = 'AlertTriangleIcon';

export const CircleIcon = React.memo(() => (
  <svg width={12} height={12} viewBox="0 0 12 12" fill="none">
    <path d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0z" fill="#C4B5FD" />
  </svg>
));
CircleIcon.displayName = 'CircleIcon';
